import { type RefObject, useLayoutEffect } from 'react';
import { playEntrance } from '@/shared/lib/motion';

type UseEntranceMotionOptions = {
  distance?: number;
  duration?: number;
  stagger?: number;
  floatPods?: boolean;
};

/** Plays the view entrance once per `viewKey` (a new view, not every re-render). */
export function useEntranceMotion(
  ref: RefObject<HTMLElement | null>,
  viewKey: string,
  options: UseEntranceMotionOptions = {},
): void {
  const { distance, duration, stagger, floatPods } = options;
  useLayoutEffect(() => {
    if (!ref.current || !viewKey) return undefined;
    return playEntrance(ref.current, { distance, duration, stagger, floatPods });
  }, [ref, viewKey, distance, duration, stagger, floatPods]);
}
